// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"059a685845069601ff17","452":"275151449dba1081ce4c","896":"958f140edae82216007b"}[chunkId] + ".js";
};